// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* login.css */

.login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw !important;
  margin: 0;
}

.login-container .card {
  /* width: 300px; */
  width: 100% !important;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.login-container .card .card-header {
  background-color: #007bff;
  color: #fff;
  padding: 15px;
  text-align: center;
  font-size: 18px;
}

.login-container .card .card-body {
  padding: 20px;
}

.login-container .card .card-body .form-group {
  margin-bottom: 20px;
}

.login-container .card .card-body .form-group label {
  display: block;
  font-weight: bold;
  margin-bottom: 5px;
}

.login-container .card .card-body .form-group .form-control {
  width: 100%;
  padding: 8px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.login-container .card .card-body button {
  width: 100%;
  padding: 10px;
  background-color: #dc3545;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.login-container .card .card-body button:hover {
  background-color: #c82333;
}

.login-container .line {
  height: 3px;
  width: 30%;
  background-color: #007bff;
  margin: 20px auto;
}

/* Optional: Add some responsive styles */

@media (max-width: 600px) {
  .login-container .card {
    width: 80%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Dashboard/logIn/login.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,yCAAyC;;AAEzC;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["/* login.css */\n\n.login-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100vw !important;\n  margin: 0;\n}\n\n.login-container .card {\n  /* width: 300px; */\n  width: 100% !important;\n  background-color: #fff;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.login-container .card .card-header {\n  background-color: #007bff;\n  color: #fff;\n  padding: 15px;\n  text-align: center;\n  font-size: 18px;\n}\n\n.login-container .card .card-body {\n  padding: 20px;\n}\n\n.login-container .card .card-body .form-group {\n  margin-bottom: 20px;\n}\n\n.login-container .card .card-body .form-group label {\n  display: block;\n  font-weight: bold;\n  margin-bottom: 5px;\n}\n\n.login-container .card .card-body .form-group .form-control {\n  width: 100%;\n  padding: 8px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-sizing: border-box;\n}\n\n.login-container .card .card-body button {\n  width: 100%;\n  padding: 10px;\n  background-color: #dc3545;\n  color: #fff;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.login-container .card .card-body button:hover {\n  background-color: #c82333;\n}\n\n.login-container .line {\n  height: 3px;\n  width: 30%;\n  background-color: #007bff;\n  margin: 20px auto;\n}\n\n/* Optional: Add some responsive styles */\n\n@media (max-width: 600px) {\n  .login-container .card {\n    width: 80%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
